import StepDone from '@/features/ecommerce/steps/StepDone';
import StepPaymentFailed from '@/features/ecommerce/steps/StepPaymentFailed';

// Both the current (unpatched) e-commerce backend contract (stage_I / payment
// / payment_completed) and the target one (stage_order / payment /
// stage_payment_success / stage_payment_failed) are mapped here, so the FE
// keeps working against whichever is deployed.
export const stages = {
  stage_I: {
    component: null,
    progress: 'default',
  },
  stage_order: {
    component: null,
    progress: 'default',
  },
  payment: {
    // No dedicated screen: the summary stays on screen (with the pay button
    // showing its own redirecting state) until the browser actually navigates
    // away to payment_url.
    component: null,
    progress: 'default',
  },
  payment_completed: {
    component: <StepDone />,
    progress: 'finished',
  },
  stage_payment_success: {
    component: <StepDone />,
    progress: 'finished',
  },
  stage_payment_failed: {
    component: <StepPaymentFailed />,
    progress: 'finished',
  },
} as const;
